import { createSlice } from '@reduxjs/toolkit';

/**
 * Hydrate Initial State global LS object.
 * @type {Object}
 */
const initialFilterOptions = {
  sort: 'rate',
};

const filtersSlice = createSlice({
  name: 'lenderspotlight/filters',
  initialState: {
    options: initialFilterOptions,
  },
  reducers: {
    filterSet: (state, action) => {
      state.options = {
        ...initialFilterOptions,
        ...action.payload,
      };
    },
  },
});

export default filtersSlice.reducer;

export const { filterSet } = filtersSlice.actions;
